import { render, staticRenderFns } from "./teacherEdit.vue?vue&type=template&id=bb5043ae&scoped=true&"
import script from "./teacherEdit.vue?vue&type=script&lang=js&"
export * from "./teacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./teacherEdit.vue?vue&type=style&index=0&id=bb5043ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5043ae",
  null
  
)

export default component.exports